var exports = {
  "ZH": "GuildBadge.module__badgeWrapper___d1ZxMW",
  "qS": "GuildBadge.module__badge___d1ZxMW",
  "eT": "GuildBadge.module__badgeOnLightSurface___d1ZxMW",
  "YW": "GuildBadge.module__badgeBanner___d1ZxMW",
  "e$": "GuildBadge.module__badgeBannerDark___d1ZxMW",
};

module.exports = exports;
